import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import API from '../../api'
import { generateQueryForTrip, setGuestParams } from '../../utils'
import { createUrl } from '../../localized-urls'
import { showItineraryPopup, setItineraryData } from '../../actions/main-actions'
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl'
import PriceConverter from '../helpers/PriceConverter'
import DateFormat from '../helpers/DateFormat'
import Loader from '../helpers/Loader'
import moment from 'moment'

const PAGE_SIZE = 4

const msg = defineMessages({
  tooltipCharter: {
    id: 'tooltip.charter',
    defaultMessage: 'Want some more information on prices and conditions? Just click to start our our live chat',
  },
  tooltipAvailability: {
    id: 'tooltip.availability',
    defaultMessage: 'Availability can change rapidly. Write us in our live chat now and we will double check the availability for you',
  },
})

class BoatTrips extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      firstLoading: true,
      revert: false,
      ...props.selectedParams,
      page: 1,
      trips: [
        { id: 1, startDate: new Date(), duration: 7, title: 'Trip title is loading' },
        { id: 2, startDate: new Date(), duration: 7, title: 'Trip title is loading' },
        { id: 3, startDate: new Date(), duration: 7, title: 'Trip title is loading' },
        { id: 4, startDate: new Date(), duration: 7, title: 'Trip title is loading' },
      ], // Fake data
    }
  }

  componentDidMount() {
    this.getTrips()
  }

  getTrips = () => {
    const { id, model, modelId } = this.props

    let filters = {
      ...this.props.selectedParams,
      page: this.state.page,
      page_size: PAGE_SIZE,
    }

    if(this.state.departureDateLess) {
      filters.departure_date_less_then = this.state.departure_date
      filters.departure_date = undefined
    } else {
      filters.departure_date = this.state.departure_date
    }

    return API(`search/liveaboards/${id}/${model.toLowerCase()}/${modelId}/trips/`).get(filters).then((trips) => {
      if(this.state.departureDateLess) {
        trips.results.reverse()
      }

      this.setState({
        trips: trips.results,
        previous: trips.previous,
        next: trips.next,
        totalTrips: trips.count,
        loading: false,
        firstLoading: false,
      }, () => {
        ReactTooltip.rebuild()
      })
    })
  }

  onPageChange = (next) => {
    let page; let departureDateLess = this.state.departureDateLess

    if(this.state.departureDateLess) {
      page = next ? this.state.page - 1 : this.state.page + 1
    } else {
      page = next ? this.state.page + 1 : this.state.page - 1
    }

    if(page < 1) {
      page = 1

      if(!this.state.previous && this.checkPreviousTrips()) {
        departureDateLess = !departureDateLess
      }
    }

    this.setState({
      page,
      departureDateLess,
      loading: true,
    }, this.getTrips)
  }

  checkPreviousTrips = () => {
    return moment(this.state.departure_date).startOf('month') > moment().startOf('month')
  }

  showItinerary = (trip) => {
    this.props.dispatch(setItineraryData({
      isCharter: trip.isCharter,
      itinerarySlug: trip.itinerarySlug,
      tripId: trip.id,
      dateFrom: trip.startDate,
      duration: trip.duration,
      currency: this.props.currency,
      shopSlug: this.props.shopSlug,
      countrySlug: this.props.countrySlug,
      insurance: this.props.insurance,
    }))
    this.props.dispatch(showItineraryPopup(true))
  }

  render() {
    const { intl, selectedParams } = this.props

    return (
      <Fragment>
        <div className={`pricing${this.state.loading ? ' loading' : ''}`}>
          <Loader />

          <ReactTooltip effect='solid' className='react-small-tooltip' />
          {
            !this.state.totalTrips && !this.state.loading ? (
              <div className='no-trips'>
                {
                  this.state.departure_date
                    ? (<Fragment>
                      { this.state.previousTrips ? (
                        <FormattedMessage id='no_available_trips_month' defaultMessage='No trips in this month' />
                      ) : (<FormattedMessage id='no_available_trips_dates' defaultMessage='No trips in chosen dates' />)
                      }
                    </Fragment>) : (<FormattedMessage id='no_available_trips' defaultMessage='No available trips' />)
                }
              </div>
            ) : ''
          }
          {
            this.state.trips.map((trip) => {
              const noSpacesForSelectedGuests = selectedParams.totalGuests > trip.availableSpots
              return (
                <div
                  onClick={(e) => {
                    e.stopPropagation()
                    setGuestParams(selectedParams)
                    window.open(createUrl('la_page', { location: this.props.countrySlug, slug: this.props.shopSlug }, generateQueryForTrip(trip, this.props.isWidget)), '_blank')
                  }}
                  className={`row${trip.grossPrice < trip.compareAtPrice ? ' is-deal' : ''}${!trip.availableSpots ? ' sold-out-label' : ''} ${noSpacesForSelectedGuests && trip.availableSpots ? 'no-space' : ''}`}
                  key={trip.id} >
                  <div className='cell date'>
                    <span className='day'><DateFormat date={trip.startDate} format='D' /></span>
                    <span className='month'><DateFormat date={trip.startDate} format='MMM' /></span>
                  </div>
                  <div className='cell mobile-group-cell'>
                    <div className='cell dives-duration'>
                      <span className='duration'>
                        <FormattedMessage id='duration_period'
                          defaultMessage='{ nights } nights/{ days } days'
                          values={
                            {
                              nights: trip.duration,
                              days: trip.duration + 1,
                            }
                          }
                        />
                      </span>
                      <span className='dives'>
                        {
                          trip.numberOfDivesMax ? (
                            <FormattedMessage
                              id='dives_min_max'
                              defaultMessage='{ divesMin } - { divesMax } dives'
                              values={
                                {
                                  divesMin: trip.numberOfDivesMin,
                                  divesMax: trip.numberOfDivesMax,
                                }
                              }
                            />
                          ) : (
                            <FormattedMessage
                              id='dives_min'
                              defaultMessage='{ divesMin } dives'
                              values={
                                {
                                  divesMin: trip.numberOfDivesMin,
                                }
                              }
                            />
                          )
                        }</span>
                    </div>
                    <div className='cell itinerary' onClick={(e) => { e.stopPropagation(); this.showItinerary(trip) }}>
                      <i className='font-icons route-icon' />
                      <span>{ trip.title }</span>
                    </div>
                  </div>
                  <div className='cell availability'>
                    {
                      trip.availableSpots && trip.availableSpots < 5 && !noSpacesForSelectedGuests
                        ? <FormattedMessage id='spots_left' values={{
                          qty: trip.availableSpots,
                        }} defaultMessage='Only { qty, plural, one {# spot } other {# spots } } left' /> : ''
                    }
                    {
                      trip.availableSpots && trip.availableSpots >= 5 && !noSpacesForSelectedGuests ? (<span className='color-green'><FormattedMessage id='available' defaultMessage='Available' /></span>) : ''
                    }
                    { noSpacesForSelectedGuests && trip.availableSpots
                      ? (<span className='color-yellow'>
                        <FormattedMessage id='no_availability_for_your_number' defaultMessage='No availability for your # of guests' />
                      </span>) : ''
                    }
                  </div>
                  <div className='cell pricing'>
                    {
                      trip.availableSpots && !trip.isCharter
                        ? (<Fragment>
                          {
                            trip.grossPrice < trip.compareAtPrice
                              ? (<span className='old-price'>
                                <PriceConverter amount={trip.compareAtPrice} currency={this.props.currency} />
                              </span>) : ''
                          }
                          <span className='price'>
                            <PriceConverter amount={trip.grossPrice} currency={this.props.currency} />
                            <span className='price-type'>/ <FormattedMessage id='trip' defaultMessage='trip' /></span>
                          </span>
                          { trip.grossPrice < trip.compareAtPrice ? (
                            <span className='deal-label'><FormattedMessage id='save' defaultMessage='Save' />&nbsp;
                              <PriceConverter amount={trip.compareAtPrice - trip.grossPrice} currency={this.props.currency} noCurrency />
                            </span>
                          ) : ''}
                        </Fragment>) : ''
                    }
                    {
                      trip.availableSpots && trip.isCharter
                        ? (<span className='charter'><FormattedMessage id='charter_only' defaultMessage='Charter only' /></span>)
                        : ''
                    }
                    {
                      trip.availableSpots === 0
                        ? (<span className='sold-out'><FormattedMessage id='sold_out' defaultMessage='Sold out' /></span>)
                        : ''
                    }
                  </div>
                  <div className='cell actions'>
                    {
                      trip.availableSpots > 0 && trip.isCharter
                        ? (<span className='charter-icon tooltip-wrapper-block' onClick={(e) => { e.stopPropagation(); document.getElementById('livechat').click() }} data-tip={intl.formatMessage(msg.tooltipCharter)}>?</span>)
                        : ''
                    }
                    {
                      trip.availableSpots === 0
                        ? (<span className='sold-out-btn tooltip-wrapper-block' data-tip={intl.formatMessage(msg.tooltipAvailability)} onClick={(e) => { e.stopPropagation(); document.getElementById('livechat').click() }}>?</span>)
                        : ''
                    }
                  </div>
                </div>)
            })
          }
        </div>
        {
          this.state.firstLoading ? (<div className='next-month placeholder'>
            <div className='prev' />
            <div className='next' />
          </div>) : ''
        }
        {
          this.state.totalTrips || this.state.previousTrips
            ? (<div className='next-month'>
              {
                this.state.departureDateLess && this.state.next || !this.state.departureDateLess && (this.state.previous || this.checkPreviousTrips())
                  ? (<div className='prev' onClick={() => this.onPageChange(false)}>
                    <i className='font-icons left-arrow-icon' /><span className='visible-xs'>
                      <FormattedMessage id='previous' defaultMessage='Previous' /></span>
                    <span className='hidden-xs'>
                      <FormattedMessage id='prev_4_trips' defaultMessage='Previous 4 trips' />
                    </span>
                  </div>) : ''
              }
              {
                this.state.departureDateLess || !this.state.departureDateLess && this.state.next
                  ? (<div className='next'
                    onClick={() => { this.onPageChange(true) }}>
                    <span className='visible-xs'><FormattedMessage id='next' defaultMessage='Next' /></span>
                    <span className='hidden-xs'><FormattedMessage id='next_4_trips' defaultMessage='Next 4 trips' /></span>
                    <i className='font-icons right-arrow-icon' />
                  </div>) : ''
              }
            </div>) : ''
        }
      </Fragment>
    )
  }
}

BoatTrips.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(connect(
  _ => ({})
)(BoatTrips))
